import styled, { css } from 'styled-components';
import { media } from 'utils/detection';

export default styled.p`
  flex: 1;
  display: block;
  color: ${props => props.theme.textBlue};
  font-family: 'Galano Classic';
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.39px;
  padding: 0;
  margin: 0 0 12px 0;
  
  ${props => props.active && css`
    color: ${props.theme.textLightGreen};
  `}

  ${media.medium`
    display: inline-flex;
    color: ${props => props.theme.textBlue };
    font-size: 1rem;
    line-height: 1.95rem;
    font-weight: 500;
    letter-spacing: 0.11rem;
    margin: 0 0 1rem 0;
    cursor: pointer;
    white-space: nowrap;
    transition-property: color;
    transition-duration: 0.3s;
    transition-timing-function: ease;

    &:hover {
      color: ${props => props.theme.textLightGreen};
      font-weight: 700;
    }

    ${props => props.active && css`
      color: ${props.theme.textLightGreen};
      font-weight: 700;
    `}
  `}
`;
